import { auth } from "../services/firebase";
import { deleteUserCloudRecord, writeUserCloudRecord } from "./userDataCloudSync";

const STORAGE_KEY = "manucalc_ai_conversations_v1";
export const AI_CONVERSATIONS_COLLECTION = "aiConversations";
export const AI_CONVERSATIONS_STORAGE_KEY = STORAGE_KEY;
export const AI_CONVERSATIONS_SYNC_EVENT = "manucalc:ai-conversations-updated";

const safeParse = (value) => {
  try {
    const parsed = JSON.parse(value || "[]");
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
};

export const getAIConversations = () => {
  if (typeof window === "undefined") return [];
  return safeParse(window.localStorage.getItem(STORAGE_KEY))
    .sort((a, b) => new Date(b.updatedAt || 0) - new Date(a.updatedAt || 0));
};

export const saveAIConversation = (conversation) => {
  const conversations = getAIConversations();
  const now = new Date().toISOString();
  const record = {
    ...conversation,
    id: conversation.id || `ai-conversation-${Date.now()}`,
    title: conversation.title || conversation.messages?.find((message) => message.role === "user")?.content?.slice(0, 72) || "Manufacturing Assistant Conversation",
    createdAt: conversation.createdAt || now,
    updatedAt: now,
  };
  const next = conversations.some((item) => item.id === record.id)
    ? conversations.map((item) => item.id === record.id ? record : item)
    : [record, ...conversations];
  window.localStorage.setItem(STORAGE_KEY, JSON.stringify(next));
  window.dispatchEvent(new CustomEvent(AI_CONVERSATIONS_SYNC_EVENT, { detail: { conversation: record } }));
  writeUserCloudRecord(AI_CONVERSATIONS_COLLECTION, record, auth.currentUser);
  return record;
};

export const deleteAIConversation = (conversationId) => {
  window.localStorage.setItem(
    STORAGE_KEY,
    JSON.stringify(getAIConversations().filter((item) => item.id !== conversationId))
  );
  window.dispatchEvent(new CustomEvent(AI_CONVERSATIONS_SYNC_EVENT, { detail: { deletedId: conversationId } }));
  deleteUserCloudRecord(AI_CONVERSATIONS_COLLECTION, conversationId, auth.currentUser);
};

export const renameAIConversation = (conversationId, title) => {
  const next = getAIConversations().map((conversation) =>
    conversation.id === conversationId
      ? { ...conversation, title, updatedAt: new Date().toISOString() }
      : conversation
  );
  window.localStorage.setItem(STORAGE_KEY, JSON.stringify(next));
  const renamed = next.find((conversation) => conversation.id === conversationId) || null;
  if (renamed) {
    window.dispatchEvent(new CustomEvent(AI_CONVERSATIONS_SYNC_EVENT, { detail: { conversation: renamed } }));
    writeUserCloudRecord(AI_CONVERSATIONS_COLLECTION, renamed, auth.currentUser);
  }
  return renamed;
};
